import { AfterViewInit, ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { betslipSelector } from '../../../base/store/selectors';
import { IBetslipRootState, IBetslipState } from '../../../base/store/state';
import { BetslipState } from '../../../core/betslip-state';

@Component({
    selector: 'bs-betslip-edit-mybet',
    templateUrl: './edit-bet.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./edit-bet.component.scss'],
    standalone: false,
})
export class EditMybetComponent implements AfterViewInit {
    @HostBinding('class') className = 'betslip';
    @Input() inColumn = false;
    betslipState$: Observable<IBetslipState>;

    constructor(
        private trackingService: TrackingService,
        store: Store<IBetslipRootState>,
    ) {
        this.betslipState$ = store.select(betslipSelector);
    }

    ngAfterViewInit(): void {
        this.trackingService.track(trackingConstants.EVENT_PAGE_VIEW, {
            [trackingConstants.PAGE_NAME]: 'sports/EditBet',
            [trackingConstants.PAGE_SITE_SECTION]: 'myBets',
        });
    }

    isEditBetInProgress(betslipState: IBetslipState): boolean {
        return betslipState.base.state === BetslipState.Placing;
    }
}
